import { createSelector } from 'reselect';

import { FILTER_MANUAL_TESTS } from './constants';

const jobs = (store) => store.apps.jobs;

export const filtersSelector = createSelector([jobs], (jobsStore) => (jobsStore.filters));

export const getUsersSelector = createSelector([
  jobs,
], (jobsStore) => ({
  users: jobsStore.filters.get('orgUsers').toJS(),
  orgUsersLoading: jobsStore.filters.get('orgUsersLoading'),
}));

export const selectOwnerByType = createSelector(
  [
    filtersSelector,
    (store, type) => type,
  ],
  (filters, type) => filters.getIn([type, 'ownership']),
);

export const manualFiltersSelectors = createSelector([
  filtersSelector,
],
(filters) => (
  filters.get(FILTER_MANUAL_TESTS).toJS()
));
